export const COMPANY_VAT_EXEMPTION_BASIS_ID_113 = 1;
export const COMPANY_VAT_EXEMPTION_BASIS_ID_43 = 2;
export const COMPANY_VAT_EXEMPTION_BASIS_113 = 'Zwolnienie z VAT na podstawie art. 113 ust. 1 i 9';
export const COMPANY_VAT_EXEMPTION_BASIS_43 = 'Zwolnienie z VAT na podstawie art. 43 ust. 1';

export const COMPANY_SETTLEMENT_METHOD_KASOWA_ID = 2;
export const COMPANY_SETTLEMENT_METHOD_KASOWA = 'Metoda kasowa';

// Kwota zmniejszająca podatek na skali (od 2022) — domyślna wartość pola firmy.
export const DEFAULT_FREE_TAX_AMOUNT_VALUE = 3600;
